import React, {} from 'react';
import { FaGraduationCap } from 'react-icons/fa'; 
import {  } from 'react-icons/gi'; 
const Resume = () => {
  return (
    <>
    <div class="parent-about">
        <h1>Resume</h1>
        <div class="parent-resume">
            <div class="child-resume">
                <h2><FaGraduationCap /></h2>
            </div>
            <div class="child-resume1">
                <h3>Education</h3>
            </div>
        </div>
        <div class="sub-parent-resume">
            <div class="sub-child-resume">
                <h3>2021</h3>
                <p>10th passed out <span> - Maharashtra State Board of Secondary and Higher Secondary Education</span></p>
            </div>
            <div class="sub-child-resume">
                <h3>2021-2024</h3>
                <p>Diploma in Computer Engineering <span> - MSBTE, Mumbai</span></p>
            </div>
            <div class="sub-child-resume">
                <h3>2024 - Present</h3>
                <p>Bachelor in Computer Engineering <span> - Mumbai University</span></p>
            </div>
        </div>
        <div class="sub-parent-resume-1">
            <div class="sub-child-resume-1">
                <h2>Working Skills</h2>
                <p>Web Design <span>85%</span></p>
                <hr class="progress-bar" style={{width: "85%"}}></hr>
                <p>Mobile App <span>65%</span></p>
                <hr class="progress-bar" style={{width: "65%"}}></hr>
                <p>Argumented Reality <span>75%</span></p>
                <hr class="progress-bar" style={{width: "75%"}}></hr>
                <p>Virtual Reality <span>90%</span></p>
                <hr class="progress-bar" style={{width: "90%"}}></hr>
            </div>
            <div class="sub-child-resume-2">
                <h2>Knowledges</h2>
                <div class="sub-child-resume-2-content">
                    <p>Digital Design</p>
                    <p>Marketing</p>
                </div>
                <div class="sub-child-resume-2-content">
                    <p>communcation</p>
                    <p>Print</p>
                </div>
                <div class="sub-child-resume-2-content">
                    <p>Soical Media</p>
                    <p>React</p>
                    <p>JS</p>
                </div>
                <div class="sub-child-resume-2-content">
                    <p>Time Management</p>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};

export default Resume;
